import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    padding: '30px 0',
    flexGrow: 1,
    flexDirection: 'column',
    '& .MuiStepper-root': {
      padding: 0,
    },
  },
  paper: {
    width: '96%',
  },
  bottomlabel: {
    fontSize: 14,
    fontWeight: 400,
    color: '#4860CF',
  },
  skiptext: {
    fontSize: 20,
    fontWeight: 700,
    color: '#4860CF',
    cursor: 'pointer',
  },
  payinpersonbtn: {
    padding: '6px 15px',
    margin: '0 0 0 30px',
  },
  price: {
    fontSize: 32,
    color: '#4860CF',
  },
  quantitycounterbox: {
    border: '2px solid #E1E7E9',
    borderRadius: '5px',
    backgroundColor: '#FDFDFD',
    padding: ' 5px',
    display: 'inline-flex',
    justifyContent: 'center',
  },
  quantitycounteraction: {
    color: '#4860CF',
    fontSize: '21px',
    fontWeight: 500,
    padding: '5px',
    width: '30px',
    height: '30px',
  },
  quantitycounter: {
    color: '#656565',
    fontSize: '20px',
    fontWeight: 700,
    padding: '0 15px',
  },
  divider: {
    border: '1px solid #4860CF',
  },
  totalbox: {
    backgroundColor: '#F1F2F2',
    boxShadow: '0 2px 10px 0 rgba(0,0,0,0.08)',
  },
  labeltext: {
    color: '#232730',
    fontSize: '24px',
    fontWeight: 500,
  },
  taxtotaltext: {
    color: '#242831',
    fontSize: '32px',
    fontWeight: 500,
    width: '200px',
    display: 'inline-flex',
    justifyContent: 'flex-end',
  },
  totaltext: {
    color: '#242831',
    fontSize: '32px',
    fontWeight: 700,
    width: '200px',
    display: 'inline-flex',
    justifyContent: 'flex-end',
    [theme.breakpoints.down('sm')]: {
      width: '50%',
    },
  },
  checkboxfieldstyle: {
    /* display: 'flex', */
    flexDirection: 'row',
    alignItems: 'center',
    fontSize: 20,
    fontWeight: 400,
    color: '#353755',
    flexWrap: 'wrap',
    '&>span>span': {
      position: 'absolute',
      marginLeft: -40,
      marginTop: -6,
    },
    paddingLeft: '29px !important',
  },
  confirmationcontentbox: {
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '0 15px',
  },
  confirmationheading: {
    color: '#4860CF',
    fontSize: '27px',
    textAlign: 'center',
    marginBottom: theme.spacing(2),
  },
  confirmationtext: {
    color: '#353755',
    fontSize: '20px',
    textAlign: 'center',
    marginBottom: theme.spacing(8),
  },
  confirmationtextlink: {
    color: '#4860CF',
    fontSize: '19px',
    textDecoration: 'underline',
  },
  schedulebtn: {
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
  },
  pdfContainer: {
    border: '2px solid #979797',
    borderRadius: '5px',
    height: 600,
    overflow: 'auto',
  },
  createnewpasswordmodal: {
    '& .MuiDialog-paperFullWidth': {
      padding: theme.spacing(4),
      alignItems: 'center',
      justifyContent: 'center',
    },
    '& .MuiDialogActions-root': {
      position: 'absolute',
      top: 0,
      right: 0,
    },
  },
  canvasConatiner: {
    // '&>canvas': {
    //   width: '100% !important',
    //   height: 'auto !important',
    // },
  },
  cardouter: {
    border: '2px solid #fff',
    display: 'inline-flex',
    padding: '5px',
  },
  cardtypelabel: {
    fontSize: '16px',
    color: '#4860CF',
    fontWeight: 'bold',
    marginLeft: '5px',
    marginBottom: '5px',
  },
  checkboxGroup: {
    '& .MuiFormControlLabel-root': {
      alignItems: 'flex-start',
    },
    '& .MuiFormControlLabel-label': {
      marginTop: 5,
    },
  },
  packagerowheading: {
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  packagedivider: {
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  packagedetails: {
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
    },
  },
  clientstepper: {
    [theme.breakpoints.down('sm')]: {
      '& .MuiStepper-root': {
        padding: '0',
      },
      '& .MuiStepLabel-labelContainer': {
        display: 'none',
      },
    },
  },
  noteLabel: {
    fontSize: '16px',
    color: '#FF0000',
    fontWeight: 'bold',
  },
  mainlogowrapper: {
    width: 'auto',
    height: '70px',
  },
  img: {
    objectFit: 'contain',
    width: '100%',
    height: '100%',
  },
  /*  logoutBtn: {
    position: 'absolute',
    right: '15px',
  }, */
  loginButtonContainer: {
    paddingTop: '10px',
    textAlign: 'center',
  },
  infoContainer: {
    position: 'relative',
    left: '5px',
  },
}));

export default useStyles;
